/**
 * Singleton QueryClient.
 * Exported so both main.tsx (Provider) and routes/index.tsx (beforeLoad guard)
 * share the exact same instance and cache.
 */
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
})

export function getQueryClient() {
  return queryClient
}
